export default __webpack_public_path__ + "static/media/regulatory_compliance_solutions-dk.64a3c9c2.svg";